export default __webpack_public_path__ + "static/media/253.36d2308f.jpg";